export enum DateFormats {
    ShortDateTime = 'MM/DD/YYYY HH:mm',
    LongDateTime = 'MM/DD/YYYY HH:mm:ss',
    IsoDate = 'YYYY-MM-DD',
    ShortDate = 'MM/DD/YYYY',
    ShortYearDate = 'MM/DD/YY',
    ShortDateNoYear = 'MM/DD',
}

export enum TimeFormats {
    TwentyFourHour = 'HH:mm',
    TwelveHour = 'h:mm A',
}
